import React, { useState, useEffect } from "react";
import { authAPI } from '../../../api/api.js';
import { useLanguage } from '../../../context/LanguageContext.js';
import ButtonWithLoader from "../../../components/Button/ButtonLoader/ButtonLoader.js";
import {FaRegUser} from "react-icons/fa";
import AuthBrand from '../AuthBrand/AuthBrand.jsx';

function ForgotPassword({ navigate }) {
    const [isLinkSent, setIsLinkSent] = useState(false);
    const { t } = useLanguage();

    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        if (message) {
            const timer = setTimeout(() => setMessage(''), 5000);
            return () => clearTimeout(timer);
        }
    }, [message]);

    useEffect(() => {
        if (error) {
            const timer = setTimeout(() => setError(''), 5000);
            return () => clearTimeout(timer);
        }
    }, [error]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setMessage('');

        try {
            await authAPI.requestPasswordReset(email);
            setMessage(t('auth.forgotPassword.successDefault'));
            setEmail('');
            setIsLinkSent(true);
        } catch (err) {
            setError(err.response?.data?.message || t('auth.forgotPassword.sendFailed'));
        } finally {
            setLoading(false);
        }
    };


    return (
      <main className="auth-page">
          <AuthBrand corner to="/login" />
        <div className="auth-shell container grid">
          <div className="forgot-password-form">
            {isLinkSent ? (
              <div className="auth-card auth-verify-form">
                <div className="auth-centered-content">
                  <p className="auth-eyebrow">{t('auth.forgotPassword.successEyebrow')}</p>
                  <h2>{t('auth.forgotPassword.successTitle')}</h2>
                  <p>{message}</p>
                  <p>{t('auth.forgotPassword.checkEmail')}</p>
                  <button className="auth-secondary-button" onClick={() => navigate('/login')}>
                    {t('auth.forgotPassword.backToLogin')}
                  </button>
                </div>
              </div>
            ) : (
              <form className="auth-card " onSubmit={handleSubmit}>
                <p className="auth-eyebrow">{t('auth.forgotPassword.eyebrow')}</p>
                <h2 className="auth-title">{t('auth.forgotPassword.title')}</h2>
                <p className="auth-lede">{t('auth.forgotPassword.lede')}</p>

                <div className="auth-fields">
                  <div className="auth-field">
                    <FaRegUser className="auth-field-icon" />
                    <div className="auth-field-control">
                      <input
                        className="auth-input"
                        type="email"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        placeholder=" "
                        required
                      />
                      <label className="auth-input-label">{t('auth.fields.email')}</label>
                    </div>
                  </div>
                </div>

                <div className="auth-action-box">
                  <ButtonWithLoader
                    text={t('auth.forgotPassword.submit')}
                    loading={loading}
                    type="submit"
                  />
                </div>

                <p className="auth-link-row">
                  <strong className="auth-link" onClick={() => navigate('/login')}>
                    {t('auth.forgotPassword.login')}
                  </strong>
                </p>
              </form>
            )}
            {error && <p className="auth-message auth-message--error">{error}</p>}
          </div>
        </div>
      </main>
    );
}

export default ForgotPassword;
